import React from "react";

import { useFormContext } from "react-hook-form";

import { nameValidationPattern } from "@gp/common";

import { FormInputField } from "@components-shared/desktop/inputs";

export default function OnboardingRegistrationLastName(props: {
	labelClassName?: string;
	disabled?: boolean;
}) {
	const { labelClassName, disabled } = props;

	const { getValues, trigger, clearErrors } = useFormContext();

	return (
		<FormInputField
			id="lastName"
			name="lastName"
			className="form__field u-mar--bottom--reset"
			labelClassName={labelClassName}
			label="registration:LAST_NAME_LABEL"
			inputClassName="input input--sml input"
			placeholder="registration:LAST_NAME_PLACEHOLDER"
			pattern={{
				value: nameValidationPattern,
				message: "registration:INVALID_LAST_NAME",
			}}
			validate={{
				passValidate: () => {
					if (getValues("password")) {
						trigger("password");
					} else {
						clearErrors("password");
					}
				},
			}}
			required
			disabled={disabled}
		/>
	);
}
